module.exports = " <div :style=styles> <div class=xs-container> <slot></slot> <slot name=pulldown></slot> <slot name=pullup></slot> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.3@vue-html-loader!./~/.8.7.0@vue-loader/lib/selector.js?type=template&index=0!./~/.0.1.3@vux/src/components/scroller/index.vue
// module id = 241
// module chunks = 2